// extracted by mini-css-extract-plugin
export var bodySections = "_d9-8";
export var gray = "_d9-7";
export var green = "_d9-4";
export var iconContainer = "_d9-9";
export var iconWidgetContainer = "_d9-1";
export var phoneIcon = "_d9-2";
export var red = "_d9-5";
export var statusDot = "_d9-3";
export var widgetContainer = "_d9-0";
export var yellow = "_d9-6";